import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@playbooks/ui/components/card';
import { Skeleton } from '@playbooks/ui/components/skeleton';
import { cn } from '@playbooks/ui/lib/utils';

import type { SkeletonBaseProps } from './types';

const PhotoSkeleton = ({ className = '' }: SkeletonBaseProps) => {
	// Theme
	const rootClassName = cn('flex-column h-full', className);

	// Render
	return (
		<Card className={rootClassName}>
			<CardContent className='text-center gap-y-1 mx-auto p-4'>
				<CardHeader className='aspect-[1/1] rounded-control flex-middle overflow-hidden mx-auto w-14 mb-2'>
					<Skeleton className='leading-[inherit]' />
				</CardHeader>
				<CardTitle>
					<Skeleton className='w-1/2' />
				</CardTitle>
				<CardDescription>
					<Skeleton className='w-3/4' />
				</CardDescription>
			</CardContent>
		</Card>
	);
};
export { PhotoSkeleton };
